import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Location, LocationStrategy, PathLocationStrategy, PopStateEvent } from '@angular/common';
import 'rxjs/add/operator/filter';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavbarComponent } from '../../components/navbar/navbar.component';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import PerfectScrollbar from 'perfect-scrollbar';

declare var $ :any;

import { NgxUiLoaderService } from 'ngx-ui-loader';

import * as sha512 from 'crypto-js/sha512';

import { ExternoService } from '../../services/externo/externo.service';
import { PagosService } from '../../services/pagos/pagos.service';
import { DataService } from '../../services/utils/data/data.service';
import { Session } from '../../services/session/session.service';

@Component({
  selector: 'login',
  templateUrl: './comprobantes.component.html',
  styleUrls: ['./comprobantes.component.scss'],
})
export class ComprobantesComponent implements OnInit {
  private _router: Subscription;
  private lastPoppedUrl: string;
  private yScrollStack: number[] = [];
  public buscarForm: any;
  public buscarResponse: string = "";
  public resultado = false;

  public pagosPendientes : any = [];

  constructor(
    private ngxService: NgxUiLoaderService,
    public location: Location,
    private router: Router,
    private formBuilder: FormBuilder,
    private externoService: ExternoService,
    private pagosService: PagosService,
    private dataService:DataService,
    private session: Session
  ) {}

  ngOnInit() {
    this.buscarForm = this.formBuilder.group({
        rut   : ['', [Validators.required]]
    });
  }

  buscar(){
    let datos = {
      rut: this.buscarForm.get("rut").value
    }

    this.buscarResponse = "";
    if(!this.dataService.validaRut(datos.rut)){
      this.buscarResponse = "Rut no valido.";
      return;
    }

    this.resultado = false;

    this.externoService.pagosPendientesPorSocio(datos, (data) => {
      this.resultado = true;
      if(!data || data.status == 0){
        this.pagosPendientes = [];
        return;
      }
      this.pagosPendientes = data;
    });
  }

  descargarComprobante(pago){
    let filtro = {
      codigoPagos: pago.codigo
    };

    this.pagosService.comprobantePDF(filtro, document.forms['comprobantePDF']);
  }

  irAIngresar(){
    this.router.navigate(['/pages/login']);
  }

  numeroMiles(x) {
    return x.toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/comprobantes/comprobantes.component.ts